import { render, staticRenderFns } from "./FormSchema.vue?vue&type=template&id=21770557&"
import script from "./FormSchema.vue?vue&type=script&lang=coffee&"
export * from "./FormSchema.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports